import { AfterViewInit, Component, Input, ViewChild } from '@angular/core'
import { CommonModule } from '@angular/common'
import { PdfJsViewerComponent, PdfJsViewerModule } from 'ng2-pdfjs-viewer'
import { dataUriToBlob } from 'src/app/services/utils'

@Component({
  selector: 'app-pdf-viewer',
  standalone: true,
  imports: [CommonModule, PdfJsViewerModule],
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss'],
})
export class PdfViewerComponent implements AfterViewInit {
  @Input() src: string

  @ViewChild('pdfViewer') pdfViewer: PdfJsViewerComponent

  constructor() {}

  async ngAfterViewInit() {
    this.pdfViewer.pdfSrc = await dataUriToBlob(this.src)
    this.pdfViewer.refresh()
  }
}
